import { render, staticRenderFns } from "./AcceptTermsOfServiceDialog.vue?vue&type=template&id=2b0e4fc2&"
import script from "./AcceptTermsOfServiceDialog.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsOfServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTermsOfServiceDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AcceptTermsOfServiceDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCheckbox,VDivider})
